import { Match } from '../models/match';
import { apiUrl, resolveApiAssets } from '../config/api';
import { GroupStandings, TournamentGroup } from '../models/tournament';

export class TournamentService {
  private readonly groupsUrl = apiUrl('/api/groups');
  private readonly standingsUrl = apiUrl('/api/standings');
  private readonly knockoutUrl = apiUrl('/api/knockout');

  listGroups(): Promise<TournamentGroup[]> {
    return this.request<TournamentGroup[]>(this.groupsUrl);
  }

  createGroup(group: Partial<TournamentGroup> & { team_ids?: number[] }): Promise<TournamentGroup> {
    return this.request<TournamentGroup>(this.groupsUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(group)
    });
  }

  updateGroup(id: number, group: Partial<TournamentGroup> & { team_ids?: number[] }): Promise<TournamentGroup> {
    return this.request<TournamentGroup>(`${this.groupsUrl}/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(group)
    });
  }

  async deleteGroup(id: number): Promise<void> {
    await this.request<{ success: boolean }>(`${this.groupsUrl}/${id}`, { method: 'DELETE' });
  }

  async deleteAllGroups(): Promise<void> {
    await this.request<{ success: boolean }>(this.groupsUrl, { method: 'DELETE' });
  }

  generateGroupMatches(id: number, returnLeg: boolean): Promise<Match[]> {
    return this.request<Match[]>(`${this.groupsUrl}/${id}/generate-matches`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ return_leg: returnLeg })
    });
  }

  standings(): Promise<GroupStandings[]> {
    return this.request<GroupStandings[]>(this.standingsUrl);
  }

  knockout(): Promise<Match[]> {
    return this.request<Match[]>(this.knockoutUrl);
  }

  generateKnockout(): Promise<Match[]> {
    return this.request<Match[]>(`${this.knockoutUrl}/generate`, { method: 'POST' });
  }

  private async request<T>(url: string, init?: RequestInit): Promise<T> {
    const response = await fetch(url, { cache: 'no-store', ...init });
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error ?? 'Errore API');
    }

    return resolveApiAssets(data as T);
  }
}
